import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'
import PageWrapper from '/components/page-wrapper'

import HelpText from '/help/statistics'

const Statistics = () => {

  const navigate = useNavigate()
  const { user } = useContext(AppContext)

  if (user?.permissions.client_admin) return (
    <PageWrapper title="Statistics" HelpText={HelpText} heading="Statistics">
      <div className='flex flex-wrap w-full gap-5 overflow-auto max-w-full mt-10 justify-center h-full pb-20 items-center'>
        <div>Statistics coming soon...</div>
      </div>
    </PageWrapper>
  )
  else navigate("..")
}

export default Statistics